// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dt-scroll[data-v-29f4d705]{overflow:hidden;display:inline-block;height:1.5em}.dt-scroll-list[data-v-29f4d705]{display:inline-flex;flex-direction:column;transition-property:transform;transition-timing-function:cubic-bezier(.42,0,.62,1.2)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
